export enum ActionButtonEnum {
  ACTION_POS_DELETE_SENT_ITEM = "ACTION_POS_DELETE_SENT_ITEM",
  ACTION_POS_ADD_DELETE_DISCOUNT = "ACTION_POS_ADD_DELETE_DISCOUNT",
  ACTION_POS_UNLOCK_TABLE = "ACTION_POS_UNLOCK_TABLE",
  ACTION_POS_CREDIT_MEMO = "ACTION_POS_CREDIT_MEMO",
  ACTION_POS_CHANGE_PRICE_MANUALLY = "ACTION_POS_CHANGE_PRICE_MANUALLY",
  ACTION_ALLOW_USER_TO_UNDO_CLOSE_DAY = "ACTION_ALLOW_USER_TO_UNDO_CLOSE_DAY",
  ACTION_ALLOW_USER_TO_CHANGE_GENERAL_SETUP_PAGE = "ACTION_ALLOW_USER_TO_CHANGE_GENERAL_SETUP_PAGE",
  ACTION_CREATE_COMPLIMENTARY_COST_JOURNAL = "ACTION_CREATE_COMPLIMENTARY_COST_JOURNAL",
  ACTION_TRANSFER_ORDER_AFTER_PRINT_BILL_PREVIEW = "ACTION_TRANSFER_ORDER_AFTER_PRINT_BILL_PREVIEW",
  ACTION_DELETE_PAYMENTS_AND_REOPEN_ORDER = "ACTION_DELETE_PAYMENTS_AND_REOPEN_ORDER",
  ACTION_ALLOW_MANAGE_NFC_BRACELET = "ACTION_ALLOW_MANAGE_NFC_BRACELET",
  ACTION_POS_MANUAL_BREKFAST_REGISTER = "ACTION_POS_MANUAL_BREKFAST_REGISTER",
  ACTION_POS_BREKFAST_REGISTER_ADDITIONAL_GUEST = "ACTION_POS_BREKFAST_REGISTER_ADDITIONAL_GUEST",
  ACTION_POS_BREAKFAST_REGISTER_UNDO_REGISTER = "ACTION_POS_BREAKFAST_REGISTER_UNDO_REGISTER",
  ACTION_CHANGE_LEDGER_ALLOWED = "ACTION_CHANGE_LEDGER_ALLOWED",
  ACTION_POS_CLOSE_TABLE = "ACTION_POS_CLOSE_TABLE",
  ACTION_POS_PAYMENT = "ACTION_POS_PAYMENT",
  ACTION_POS_TIP = "ACTION_POS_TIP",
  ACTION_POS_TRANSFER_ORDER = "ACTION_POS_TRANSFER_ORDER",
  ACTION_POS_VOID_ORDER = "ACTION_POS_VOID_ORDER",
  ACTION_POS_DELETE_VOID_ORDER = "ACTION_POS_DELETE_VOID_ORDER",
  ACTION_POS_ALLOW_CHANGE_COLLECTION_FOR_COMPLIMENTARY_ORDER = "ACTION_POS_ALLOW_CHANGE_COLLECTION_FOR_COMPLIMENTARY_ORDER",
  // PMS-881 (D7): the e-journal and the adjustment log export a period of guest-identified receipts
  // (names, TINs, SC/PWD IDs), so unlike every other report page they are permission-gated.
  ACTION_POS_BIR_EJOURNAL = "ACTION_POS_BIR_EJOURNAL",
  ACTION_POS_MANAGE_WAITER_PIN = "ACTION_POS_MANAGE_WAITER_PIN",
}
export enum WidgetEnum {
  WIDGET_CARD_POS_TOTAL_ORDERS = "WIDGET_CARD_POS_TOTAL_ORDERS",
  WIDGET_CARD_POS_TOTAL_PAID_ORDERS = "WIDGET_CARD_POS_TOTAL_PAID_ORDERS",
  WIDGET_CARD_POS_TOTAL_OPEN_ORDERS = "WIDGET_CARD_POS_TOTAL_OPEN_ORDERS",
  WIDGET_CARD_POS_TOTAL_CANCELED_ORDERS = "WIDGET_CARD_POS_TOTAL_CANCELED_ORDERS",
  WIDGET_CARD_POS_TOTAL_OPEN_OUTLETS = "WIDGET_CARD_POS_TOTAL_OPEN_OUTLETS",
  WIDGET_CARD_POS_TOTAL_CLOSED_OUTLETS = "WIDGET_CARD_POS_TOTAL_CLOSED_OUTLETS",
  WIDGET_CHART_POS_TOP_10_SOLD_QTY = "WIDGET_CHART_POS_TOP_10_SOLD_QTY",
  WIDGET_CHART_POS_TOP_10_SOLD_AMOUNT = "WIDGET_CHART_POS_TOP_10_SOLD_AMOUNT",
  WIDGET_CHART_POS_SUMMARY_METRIC_DATA = "WIDGET_CHART_POS_SUMMARY_METRIC_DATA",
  WIDGET_CHART_POS_PAYMENT = "WIDGET_CHART_POS_PAYMENT",
  WIDGET_CHART_POS_REVENUE = "WIDGET_CHART_POS_REVENUE",
  WIDGET_CHART_POS_TOP_3_ITEM_SOLD = "WIDGET_CHART_POS_TOP_3_ITEM_SOLD",
  WIDGET_CHART_POS_TOP_DISCOUNT = "WIDGET_CHART_POS_TOP_DISCOUNT",
  WIDGET_CARD_POS_TOTAL_REVENUE = "WIDGET_CARD_POS_TOTAL_REVENUE",
  WIDGET_CARD_POS_TOTAL_ITEM_SOLD = "WIDGET_CARD_POS_TOTAL_ITEM_SOLD",
  WIDGET_CARD_POS_TOTAL_TRANSACTION = "WIDGET_CARD_POS_TOTAL_TRANSACTION",
  WIDGET_CARD_POS_TOTAL_COVERS = "WIDGET_CARD_POS_TOTAL_COVERS",
  WIDGET_CARD_POS_AVERAGE_SPEND_PER_GUEST = "WIDGET_CARD_POS_AVERAGE_SPEND_PER_GUEST",
  WIDGET_CARD_POS_AVERAGE_TRANSACTION_VALUE = "WIDGET_CARD_POS_AVERAGE_TRANSACTION_VALUE",
  WIDGET_CARD_POS_AVERAGE_TABLE_TURN_TIME = "WIDGET_CARD_POS_AVERAGE_TABLE_TURN_TIME",
  WIDGET_CARD_POS_SEATING_CAPACITY = "WIDGET_CARD_POS_SEATING_CAPACITY",
  WIDGET_CARD_POS_OCCUPANCY_RATE = "WIDGET_CARD_POS_OCCUPANCY_RATE",
  WIDGET_CHART_POS_TOP_DISCOUNTS = "WIDGET_CHART_POS_TOP_DISCOUNTS",
}
